import React, { ChangeEvent, useState } from 'react'
import { useStore } from 'effector-react'
import {
  $countrySetting,
  setCountrySetting,
  submitCreateCountrySetting,
} from './model'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CModal,
  CModalBody,
  CRow,
} from '@coreui/react-pro'
import { $settingCountryList } from '../list/model'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const CreateCountrySetting: React.FC<Props> = ({
  isVisible,
  onClose,
}) => {
  const countrySetting = useStore($countrySetting)
  const settingCountryList = useStore($settingCountryList)

  const [validated, setValidated] = useState(false)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    value = event.currentTarget.value

    setCountrySetting({
      ...countrySetting,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreateCountrySetting(
        [
          ...settingCountryList,
          {
            countryCode: countrySetting.name,
          },
        ].map((item) => item.countryCode),
      ),
        event.preventDefault()
      event.stopPropagation()
      onClose()
    }
    setValidated(true)
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      <CCard>
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Create country setting</strong>
        </CCardHeader>
        <CCardBody>
          <CForm noValidate validated={validated} onSubmit={handleSubmit}>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  name="name"
                  value={countrySetting.name}
                  onChange={handleChange}
                  label="Country code"
                  minLength={3}
                  maxLength={3}
                  required
                />
              </CCol>
            </CRow>
            <CButton className="mb-3" type="submit">
              Create
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CModal>
  )
}
